export default "__VITE_ASSET__pC372zs7__"